import script from "./menuListMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./menuListMobile.vue?vue&type=script&setup=true&lang=js"

import "./menuListMobile.vue?vue&type=style&index=0&id=f410f220&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f410f220"]])

export default __exports__